// pages/ForgotPassword.jsx
import React from "react";
import ForgotPasswordForm from "../components/ForgotPasswordForm";

export default function ForgotPassword() {
  return (
      <ForgotPasswordForm/>               
  );
}
